import Chip from "@mui/material/Chip";

export const getComunicadoStatus = (comunicado, comunicadoAprovacao) => {
  if (comunicado.enviado) {
    return comunicado.finalizadoEnvio
      ? { label: "Enviado", color: "success" }
      : { label: "Enviando", color: "info" };
  }
  if (comunicadoAprovacao && !comunicado.aprovado) {
    return { label: "Aguardando aprovação", color: "warning" };
  }
  if (comunicado.agendado) {
    return { label: "Agendado", color: "secondary" };
  }
  if (comunicadoAprovacao && comunicado.aprovado) {
    return { label: "Aprovado", color: "primary" };
  }
  return { label: "Não enviado", color: "default" };
};

const ComunicadoStatusChip = ({ comunicado, comunicadoAprovacao, ...rest }) => {
  const { label, color } = getComunicadoStatus(comunicado, comunicadoAprovacao);
  return <Chip size="small" variant="outlined" label={label} color={color} {...rest} />;
};

export default ComunicadoStatusChip;
